<div class="ruler-container" [ngClass]="vertical ? 'vertical' : 'horizontal'">
  <canvas #myCanvas></canvas>
</div>
